// Efficiency test criteria travel as filter-catalog entries ({ key, value }), and the fields inside
// `value` follow the catalog's own wire format: snake_case (`tolerance_months`), same as the search
// page's `in_perimeter`/`market_products`. The backend refuses any other field name rather than
// silently dropping it. ComparisonCriteria.vue works in camelCase (`toleranceMonths`), so every
// criterion is converted on its way out (save, coverage check) and back in (loading a saved test).

function camelToSnake(name) {
  return name.replace(/[A-Z]/g, (letter) => '_' + letter.toLowerCase())
}

function snakeToCamel(name) {
  return name.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
}

function renameFields(value, rename) {
  return Object.keys(value || {}).reduce((renamed, field) => {
    renamed[rename(field)] = value[field]
    return renamed
  }, {})
}

// Only enabled criteria are sent; `value` as an object, which is what the backend expects on both
// /save and /coverageCheck.
export function criteriaToApi(criteria) {
  return (criteria || [])
    .filter((c) => c.value.enabled)
    .map((c) => ({ key: c.key, value: renameFields(c.value, camelToSnake) }))
}

export function criterionValueFromApi(value) {
  return renameFields(value, snakeToCamel)
}
